// extracted by mini-css-extract-plugin
module.exports = {"reveal":"Reveal_reveal__1hKuN","revealIn":"Reveal_revealIn__1XMQN"};